
































































import Vue from "vue";
import { AudioData } from "@tt-app/types";
import { AudioDecoderPlayer } from "@tt-app/utils";

import AudioElement from "@tt-app/components/exercise/common/AudioElement.vue";
import ExerciseHtmlText from "@tt-app/components/exercise/consolidated/exercise/body/ExerciseHtmlText.vue";
import ImageCard from "@tt-app/components/exercise/common/ImageCard.vue";
import ListeningAudio from "@tt-app/components/quiz/ListeningAudio.vue";

import IconChevronDown from "@joyz/app-core/assets/icons/transparent/ChevronDown.svg";

interface Data {
  icons: any;
  contentCollapsed: boolean;
}

interface Methods {
  component: (componentConfig: any) => void;
  concatenatedBody: (body: string | string[]) => string;
  toggleCollapse: () => void;
}

interface Props {
  audioData: AudioData;
  audioDecoderPlayer: AudioDecoderPlayer;
  body: any[];
  default: string;
  footer: any[];
  header: any[];
}

export default Vue.extend<Data, Methods, {}, Props>({
  name: "ListeningReviewCard",
  components: {
    ListeningAudio,
    AudioElement,
    ExerciseHtmlText,
    ImageCard
  },
  props: {
    audioData: {
      type: Object,
      default: (): AudioData => ({})
    },
    audioDecoderPlayer: {
      type: AudioDecoderPlayer,
      default: undefined
    },
    body: {
      type: Array,
      required: true
    },
    default: {
      type: String,
      default: "CLOSED"
    },
    footer: {
      type: Array,
      required: true
    },
    header: {
      type: Array,
      required: true
    }
  },
  computed: {
    audioUrl() {
      if (this.footer) {
        return this.footer[0]?.url || "";
      }

      return "";
    },
    headerTitle() {
      if (this.header) {
        return this.header[0];
      }

      return "";
    }
  },
  data() {
    const contentCollapsed = this.default === "CLOSED";

    return {
      icons: {
        chevronDown: IconChevronDown
      },
      contentCollapsed
    };
  },
  methods: {
    component(componentConfig) {
      const components: { [key: string]: string } = {
        CARD: "listening-review-card",
        HTML_TEXT: "div",
        IMAGE: "div",
        MULTIPLE_SELECTION: "listening-multiple-choice",
        PLAIN_TEXT: "div",
        SEPARATOR: "div",
        TEXT_OPTIONS_FOR_REVIEW: "div",
        AUDIO: "div"
      };

      const { type } = componentConfig;

      return components[type];
    },
    concatenatedBody(elementBody) {
      return Array.isArray(elementBody) ? elementBody.join("\n") : elementBody;
    },
    toggleCollapse() {
      this.contentCollapsed = !this.contentCollapsed;
    }
  }
});
